import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { AlertDialogComponent } from 'src/app/shared/components/alert-dialog/alert-dialog.component';
import { EntitiesServiceService } from '../../../../../services/entities-service.service';

@Component({
  selector: 'app-bph',
  templateUrl: './bph.component.html',
  styleUrls: ['./bph.component.css']
})
export class BphComponent implements OnInit, OnDestroy {
  @Input() entityId: any;
  @Input() widgetData: any;
  @Input() siteId: any;
  isloader: boolean = true;
  isError: boolean = false;
  masterBphData: any = {};
  rul = new FormControl();
  isEditable: boolean = false;
  brakePadRul: any = [];

  private _intervalTimer: any;
  private _afterClosedSusription: Subscription;
  private _fetchRulSubscription: Subscription;
  private _createRulSubscription: Subscription;
  
  constructor(public service: EntitiesServiceService, public sharedService: ServicecallService, private _dialog: MatDialog) { }

  ngOnInit(): void {
    this._fetchRul();
  }
  refreshApi() {
    if (+this.widgetData?.refreshRate) {
      this.clearTimer();
      this._intervalTimer = setInterval(() => {
        this._fetchRul();
      }, +this.widgetData?.refreshRate);
      this.isError = false;
    }
  }

  clearTimer() {
    if (this._intervalTimer) {
      clearInterval(this._intervalTimer);
    }
  }

  submitRul(type: string) {
    let dialogRef = this._dialog.open(AlertDialogComponent, {
      data: { msg: type === 'reset' ? 'Are you sure you want to reset?' : 'Are you sure you want save changes?' },
      disableClose: true
    });
    this._afterClosedSusription = dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const payload = {
          type: type,
          entityId: this.entityId,
          class: 'RUL_BRAKE_PAD',
          rulValue: type === 'reset' ? this.sharedService.resetRULDetials('RUL_BRAKE_PAD')?.lifetime : this.rul.value,
          // odometerValue: 45000
        }
        this._createRulSubscription = this.service.createRul(payload).subscribe((result: any) => {
          this.sharedService.toasterService({ type: 'success', msg: result['message'] });
          this.masterBphData = result?.data;
          this.rul.reset();
          this.rul.setValue(this.masterBphData?.rulValue);
          this._setGaugeData();
          this.refreshApi();
        });
      }
    });
  }
  infoHoverLabel(operation: string) {
    const details = '\nDesign Life : ' + (this.sharedService.resetRULDetials('RUL_BRAKE_PAD')?.lifetime).toString() + '\nRUL Predicted : ' +
      (this.masterBphData?.rulValue ? this.masterBphData?.rulValue?.toString() : '0') + '\nRUL Predicted % : ' +
      ((this.masterBphData?.rulPercentage || this.masterBphData?.rulPercentage === 0) ? ((this.masterBphData?.rulPercentage % 1) !== 0 ? this.masterBphData?.rulPercentage?.toFixed(5) : this.masterBphData?.rulPercentage) : '') +
      '\nReplacement Threshold : ' + this._getThreshold('Replace', 'upperThreshold')?.toString();
    switch (operation) {
      case 'manual': return 'Initailized by user' + details;
      case 'computed': return 'Remaining useful life computed by algorithm - ' + this.masterBphData?.type + details;
      default: return '';
    }
  }

  ngOnDestroy(): void {
    this.clearTimer();
    this._afterClosedSusription?.unsubscribe();
    this._fetchRulSubscription?.unsubscribe();
    this._createRulSubscription?.unsubscribe();
    
  }
  private _fetchRul() {
    const payload = {
      class: 'RUL_BRAKE_PAD',
      entityId: this.entityId
    };
    this._fetchRulSubscription = this.service.fetchRul(payload).subscribe(
      {
        next: (result: any) => {
          this.masterBphData = result;
          this.rul.setValue(this.masterBphData?.rulValue);
          this.isloader = false;
          this._setGaugeData();
        },
        error: (error) => {
          if (error) {
            this.isloader = false;
            this.isError = true;
            this.masterBphData.rulValue = 0;
            this._setGaugeData();
          }
        }
      }
    )
  }

  private _setGaugeData() {
    this.brakePadRul = [[
      {
        type: "indicator",
        mode: "gauge+number",
        value: this.masterBphData?.rulValue ? this.masterBphData?.rulValue : 0,
        gauge: {
          axis: { range: [null, this.sharedService.resetRULDetials('RUL_BRAKE_PAD')?.lifetime], showticklabels: false, ticks: "" },
          bar: { color: "#055C7B", thickness: .3 },
          steps: [
            { range: [this._getThreshold('Replace', 'lowerThreshold'), this._getThreshold('Replace', 'upperThreshold')], color: "#F65E4C", thickness: .5 },
            { range: [this._getThreshold('Replace', 'lowerThreshold'), this._getThreshold('Excellent', 'upperThreshold')], color: "#F2F4F3", thickness: .3 }
          ],
          bordercolor: "transparent",
        },
        height: 150,
        annotation: [
          {
            text: this.sharedService.resetRULDetials('RUL_BRAKE_PAD')?.unit + " Left",
            showarrow: false,
            y: .6,
            font: {
              family: "Inter",
              size: 18,
              color: "#615E83"
            },
          }
        ]
      }
    ]];
    this.refreshApi();
  }

  private _getThreshold(thresholdLabel: string, searchKey: string) {
    return this.sharedService.resetRULDetials('RUL_BRAKE_PAD')?.status?.find((item: any) => item?.label === thresholdLabel)?.[searchKey];
  }

  private _cancelEntry() {
    this.rul.reset();
    this.rul.setValue(this.masterBphData?.rulValue);
  }

  
}
